const API_BASE_URL = 'https://credible-definitely-doberman.ngrok-free.app';

export interface StartTaskPayload {
  // Define common properties, or use a more generic type if payloads vary widely
  [key: string]: any; 
}

export interface TaskStartResponse {
  task_id: string;
  // Potentially other fields like status, message, etc.
  [key: string]: any;
}

/**
 * Starts a task using the 'Direct Access' method (no client_token).
 * @param stateName The name of the state managing the task (e.g., 'example_task2').
 * @param taskName The specific name of the task to run (e.g., 'task1', 'task2_with_args').
 * @param payload The data to send for starting the task.
 * @returns Promise<TaskStartResponse>
 */
export const startDirectTask = async (
  stateName: string,
  taskName: string,
  payload?: StartTaskPayload // Payload is optional
): Promise<TaskStartResponse> => {
  const apiUrl = `${API_BASE_URL}/api/${stateName}/task/start/${taskName}`;

  console.log('Starting direct task with URL:', apiUrl, 'and payload:', payload);

  const requestOptions: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  if (payload) {
    requestOptions.body = JSON.stringify(payload);
  }

  const response = await fetch(apiUrl, requestOptions);

  if (!response.ok) {
    let errorDetails = `HTTP error! status: ${response.status}`;
    try {
      const errorData = await response.json();
      errorDetails += `, Message: ${JSON.stringify(errorData)}`;
    } catch (e) {
      // Ignore if response is not JSON or already read
    }
    console.error('Error starting direct task:', errorDetails);
    throw new Error(errorDetails);
  }

  return response.json();
};


// Future functions for getting task status and results can be added here.
// Example:
// export const getTaskStatus = async (stateName, clientToken, taskId) => { ... };
// export const getTaskResult = async (stateName, clientToken, taskId) => { ... };
// export const getDirectTaskResult = async (stateName, taskId) => { ... };
